import ProcessStatus from 'components/Processes/ProcessStatus'

import getRunnerStatusTitle from 'constants/runnerStatuses'

export default class RunnerStatus extends ProcessStatus {
    renderStatus = () => getRunnerStatusTitle(this.props.row.status)
}